
import RequestAbstract from "../abstract";

export default class CurrencyRates extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/currency-rates";
    }
}

